import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Oval } from "react-loader-spinner";
import { store } from "../redux/store/store";
import {
  setLoginSucess,
  setLoginFail,
  setAuthenticatedSuccess,
  setAuthenticatedFail,
  setUserLoadSuccess,
  setUserLoadFail,
} from "../redux/reducers/auth";
import { SERVER_ROUTE } from "../routes/api/api_routes";
import { isValidEmail } from "../utils/form_control";
import {
  REGISTER_PATH,
  ACCUEIL_PATH,
  RESET_PASSWORD,
  COACH_DASHBOARD_PATH,
  ADD_QUESTION_PATH,
  ADMIN_DASHBOARD_PATH,
} from "../routes/navigation/navigation_paths";
import { setToken, setCurrentUser } from "../utils/auth";
import personImg from "../images/login-image.png";
import logoImg from "../images/logo.png";
import bakeliImg from "../images/training.png";
import ButtonBakeli from "../components/login/ButtonBakeli";

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = store.dispatch;
  const [authTried, setAuthTried] = useState(false);
  const [loginUrl, setLoginUrl] = useState(null);
  const [loadingSSO, setLoadingSSO] = useState(false);

  const auth = useSelector((state) => state.auth);
  const DEFAULT_MESSAGE = "Ce champ est obligatoire!";
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm();

  useEffect(() => {
    if (!auth) return;

    // Cas : utilisateur connecté et valide
    if (
      auth.isAuthenticated === true &&
      auth.user &&
      !auth.user.detail &&
      !auth.user.code
    ) {
      if (auth.user.is_coach) {
        navigate(COACH_DASHBOARD_PATH, { replace: true });
      } else if (auth.user.is_admin) {
        navigate(ADMIN_DASHBOARD_PATH, { replace: true });
      } else {
        navigate(ACCUEIL_PATH, { replace: true });
      }
    }
  }, [auth]);

  useEffect(() => {
    getBakeliConnexionUrl()
  }, [])

  const getBakeliConnexionUrl = () => {
    fetch(`${SERVER_ROUTE}/api/v1/auth`, {
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }).then((response) => response.json())
      .then((data) => {
        console.log({ data });
        setLoginUrl(data.url)
      })
      .catch((error) => console.error(error));
  }

  function notify() {
    toast.error("Compte non actif ou identifiants incorrects!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }

  const submit = async (data) => {
    const { email, password } = data;
    setLoading(true);
    setAuthTried(true);
    try {
      // Étape 1 : Création du token
      const tokenRes = await fetch(`${SERVER_ROUTE}/auth/jwt/create/`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        mode: "cors",
        body: JSON.stringify({ email, password }),
      });
      const tokenData = await tokenRes.json();

      if (!tokenRes.ok) {
        dispatch(setLoginFail({ access: null, refresh: null }));
        setLoading(false);
        notify();
        return; // ⛔ Stop ici si login échoue
      }

      dispatch(setLoginSucess(tokenData));
      setToken(tokenData.access);

      // Étape 2 : Vérification du token
      const verifyRes = await fetch(`${SERVER_ROUTE}/auth/jwt/verify/`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        mode: "cors",
        body: JSON.stringify({ token: localStorage.getItem("access") }),
      });
      const verifyData = await verifyRes.json();

      if (!verifyRes.ok || verifyData.code === "token_not_valid") {
        dispatch(setAuthenticatedFail());
        setLoading(false);
        notify();
        return; // ⛔ Stop ici si token non valide
      }

      dispatch(setAuthenticatedSuccess());

      // Étape 3 : Récupération des infos utilisateur (await important ici)
      const userRes = await fetch(`${SERVER_ROUTE}/auth/users/me/`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.getItem("access")}`,
          Accept: "application/json",
        },
        mode: "cors",
      });
      const userData = await userRes.json();

      if (!userRes.ok) {
        dispatch(setUserLoadFail({ user: null }));
        setLoading(false);
        notify(); // ✅ Le toast s’affiche seulement après cette dernière étape
        return;
      }

      dispatch(setUserLoadSuccess(userData));
      setCurrentUser(userData);
    } catch (err) {
      dispatch(setLoginFail({ access: null, refresh: null }));
      setLoading(false);
      notify();
    }
  };

  const verificate = (data) => {
    let errorFields = [];
    if (!isValidEmail(data.email)) {
      errorFields.push({ field: "email", message: "Email non valid" });
    }
    if (data.password.length < 6) {
      errorFields.push({
        field: "password",
        message: "Mot de passe trop courte",
      });
    }
    if (errorFields.length) {
      errorFields.forEach((err) => {
        let { field, message } = err;
        setError(field, { message: message });
      });
      setLoading(false);
    } else {
      submit(data);
    }
  };

  return (
    <div className="min-h-screen outline-2 flex flex-col items-center  justify-center bg-gradient-to-br from-teal-700 to-teal-500 overflow-hidden">
      <div className="text-white flex flex-col justify-center items-center lg:items-start">
        <div className="flex items-center mb-4 gap-3 text-3xl font-bold">
          <img src={logoImg} alt="Logo " className="w-16" />
          <span>Bakeli Training</span>
        </div>
        {/* <p className="text-3xl text-center mt-3 ml-8 font-medium">
            Training the best
            <br />
            tech talent in Africa.
          </p> */}
      </div>

      {/* image + formulaire */}
      <div className="flex flex-col lg:flex-row w-full max-w-7xl justify-center items-center ">
        {/* imageperson */}
        <div className="hidden md:block lg:block">
          <img src={personImg} alt="Bakeli" className="max-w-lg" />
        </div>
        {/* formulaire */}
        <div className="bg-white p-6 rounded-2xl h-max  shadow-xl max-w-[400px] w-[100%] relative ">
          <img src={logoImg} alt="Logo" className="mx-auto w-16" />
          <h3 className="text-center text-teal-700 text-2xl font-bold mb-6 mt-3 tracking-wide">
            CONNECTEZ-VOUS
          </h3>
          <form onSubmit={handleSubmit(verificate)} className="space-y-4 mt-3">
            <input
              type="email"
              placeholder="Email"
              {...register("email", { required: DEFAULT_MESSAGE })}
              className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400 ${
                errors.email ? "border-red-500" : "border-teal-500"
              }`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email.message}</p>
            )}

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Mot de passe"
                {...register("password", { required: DEFAULT_MESSAGE })}
                className={`w-full px-4 py-2 border-2 mt-2 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400 ${
                  errors.password ? "border-red-500" : "border-teal-500"
                }`}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-2 mt-2 text-gray-500 text-lg"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
              {errors.password && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.password.message}
                </p>
              )}
            </div>

            <div className="text-right text-sm text-gray-500">
              <Link
                to={RESET_PASSWORD}
                className="text-sm text-gray-500 no-underline"
              >
                Mot de passe oublié ?
              </Link>
            </div>

            <button
              type="submit"
              className="w-[100%] bg-[#FF9800] hover:bg-yellow-600 text-white font-bold py-2 rounded-full"
              disabled={loading}
            >
              {loading ? "Loading..." : "Connexion"}
            </button>

            <ButtonBakeli logo={bakeliImg} link={loginUrl} text="Se connecter avec Bakeli" />

            <div className="flex items-center gap-2 mt-3">
              <hr className="flex-grow border-gray-300" />
              <span className="text-gray-400 text-sm">OU</span>
              <hr className="flex-grow border-gray-300" />
            </div>

            <Link
              to={REGISTER_PATH}
              className="w-full inline-block text-center no-underline border-2 border-teal-500 text-teal-600 font-semibold py-2 rounded-full hover:bg-teal-50"
            >
              <div className="flex justify-center items-center gap-2">
                S'inscrire
                <img src={bakeliImg} alt="BakeliImg" className="w-6 h-6" />
              </div>
            </Link>
          </form>

          {loading && (
            <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-75 rounded-2xl">
              <Oval
                height={40}
                width={40}
                color="#009688"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#FFA000"
                strokeWidth={4}
                strokeWidthSecondary={2}
              />
            </div>
          )}
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </div>
  );
};

export default Login;
